import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-vehicle-form',
    templateUrl: './vehicle-form.component.html',
    standalone: false
})
export class VehicleFormComponent implements OnInit{

  @Input('apiErrors') apiErrors : Map<string,string>
  @Input('eventForm') eventForm : FormGroup

  constructor() {
  }

  ngOnInit(): void {
  }

}
